import type { OptionKV } from "~styled/selector/Selector";

export enum ETipoNovedad {
  Anulacion = "Anulacion",
  Emision = "Emision",
  Siniestro = "Siniestro",
  Modificacion = "Modificacion",
  Renovacion = "Renovacion",
  Refacturacion = "Refacturacion",
  Indeterminado = "Indeterminado",
}

const TODOS = "";
export const ANULACION = ETipoNovedad.Anulacion;
export const EMISION = ETipoNovedad.Emision;
export const SINIESTRO = ETipoNovedad.Siniestro;
export const MODIFICACION = ETipoNovedad.Modificacion;
export const RENOVACION = ETipoNovedad.Renovacion;
export const REFACTURACION = ETipoNovedad.Refacturacion;
export const INDETERMINADO = ETipoNovedad.Indeterminado;

const tipoNovedadSegurosOptions: Record<ETipoNovedad | typeof TODOS, string> = {
  [TODOS]: "Todos",
  [ANULACION]: "Anulacion",
  [EMISION]: "Emision",
  [SINIESTRO]: "Siniestro",
  [MODIFICACION]: "Modificacion",
  [RENOVACION]: "Renovacion",
  [REFACTURACION]: "Refacturacion",
  [INDETERMINADO]: "Indeterminado",
};

const tiposNovedadesFilter: OptionKV<ETipoNovedad | typeof TODOS>[] = [
  { label: tipoNovedadSegurosOptions[TODOS], value: TODOS },
  { label: tipoNovedadSegurosOptions[ANULACION], value: ANULACION },
  { label: tipoNovedadSegurosOptions[EMISION], value: EMISION },
  { label: tipoNovedadSegurosOptions[SINIESTRO], value: SINIESTRO },
  { label: tipoNovedadSegurosOptions[MODIFICACION], value: MODIFICACION },
  { label: tipoNovedadSegurosOptions[RENOVACION], value: RENOVACION },
  { label: tipoNovedadSegurosOptions[REFACTURACION], value: REFACTURACION },
  { label: tipoNovedadSegurosOptions[INDETERMINADO], value: INDETERMINADO },
];

export { tipoNovedadSegurosOptions, tiposNovedadesFilter };
